
import { Instance } from '@/catalogs/api/Instance';
import PIS from '@/common/api/PIS';
import { defineComponent, PropType, ref, watch } from 'vue';
import { CatalogExportAliasesCommand } from '@/catalogs/api/runtime/CommandExecutor';
import { TranslateFunc } from '@/catalogs/composables/setupComponent';

export default defineComponent({
  props: {
    t: { type: Function as PropType<TranslateFunc>, required: true },
    instanceId: String,
    show: Boolean,
  },
  emits: ['update:show'],
  setup(props, { emit }) {
    const instance = PIS.Catalogs.getInstance(props.instanceId) as Instance;
    const showModal = ref(false);
    const close = () => emit('update:show', false);
    const onExport = async () => {
      try {
        await instance.execute(new CatalogExportAliasesCommand());
      } catch (error) {
        // Ignore Error
      }
      close();
    };

    watch(
      () => props.show,
      (isShown: boolean) => (isShown ? onExport() : null),
    );

    return {
      showModal,
      close,
      onExport,
    };
  },
});
